import PropTypes from 'prop-types'

import { ConfirmationDialog } from 'components'

import { useSnackbar } from 'hooks'
import helpers from 'helpers'
import * as service from 'service'

const SyncOmieDialog = ({ open, setOpen, paymentContractId }) => {
  const snackbar = useSnackbar()

  const handleSync = async () => {
    try {
      await service.dponet.paymentContract.syncContractOmie({
        paymentContractId,
      })

      snackbar.open({
        message: `Contrato sincronizado com sucesso.`,
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          `Falha ao sicronizar com o omie.`,
        variant: 'error',
      })
    } finally {
      setOpen(false)
    }
  }

  return (
    <ConfirmationDialog
      open={open}
      setOpen={setOpen}
      message="Você deseja sincronizar os serviços com o omie?"
      alertColor="grey"
      cancelButtonText="Cancelar"
      buttonText="Atualizar"
      actionAcceptButton={handleSync}
    />
  )
}

SyncOmieDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  paymentContractId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default SyncOmieDialog
